import { useRequestProfileContext } from '../RequestProfile.hooks'

import { RequestProfileTabInternalTasksContent } from './RequestProfileTabInternalTasksContent'
import { RequestProfileTabInternalTasksContextProvider } from './RequestProfileTabInternalTasksContextProvider'

function RequestProfileTabInternalTasks({ onLoadCounters }) {
  const { requestData } = useRequestProfileContext()

  return requestData?.id ? (
    <RequestProfileTabInternalTasksContextProvider
      canEdit={requestData.permissions?.can_edit_checklists}
      canEditDoneChecklistItem={
        requestData.permissions?.can_edit_done_checklist_item
      }
      requestId={requestData.id}
      onLoadCounters={onLoadCounters}
    >
      <RequestProfileTabInternalTasksContent />
    </RequestProfileTabInternalTasksContextProvider>
  ) : null
}

export default RequestProfileTabInternalTasks
